import React, { useRef, useEffect, useState } from 'react'

export default function Field({ name, type="text", label, value, helper, onChange, error = "", margin = true }) {
    const labelRef = useRef(null)
    const [notchMiddleWidth, setNotchMiddleWidth] = useState(0)
    const [focused, setFocused] = useState(false)
    const hasValue = value !== undefined && value !== null && value !== ""
    const isActive = hasValue || focused

    useEffect(() => {
        if (labelRef.current) {
            setNotchMiddleWidth(labelRef.current.offsetWidth * 0.8 + 8)
        }
    }, [label])

    return (
        <div className={"form-outline" + (margin ? " mb-4" : "")}>
            <input
                type={type}
                name={name}
                className={
                    "form-control" + (isActive ? " active" : "") + (
                        error ? " is-invalid" : ""
                    )
                }
                value={value}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
            />
            <label ref={labelRef} className="form-label" htmlFor={name}>{label}</label>
            <div className="form-notch">
                <div className="form-notch-leading"></div>
                <div className="form-notch-middle" style={{ width: isActive ? notchMiddleWidth : 0 }}></div>
                <div className="form-notch-trailing"></div>
            </div>
        </div>
    )
}
